var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"mobile-btn",class:{ 'outline': _vm.outline },attrs:{"type":"button","disabled":_vm.disabled},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click', $event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }